<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
  >
    <g id="组_1" data-name="组 1" transform="translate(-116 -528)">
      <line
        id="直线_1"
        data-name="直线 1"
        x2="25"
        transform="translate(116 540.5)"
        fill="none"
        stroke="#212121"
        stroke-width="5"
      />
      <line
        id="直线_2"
        data-name="直线 2"
        x2="25"
        transform="translate(128.5 528) rotate(90)"
        fill="none"
        stroke="#212121"
        stroke-width="5"
      />
    </g>
  </svg>
</template>
